import { createWithEqualityFn } from 'zustand/traditional'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AuthSessionStore {
	accessToken?: string
	setAccessToken: (accessToken: string) => void
	clearState: () => void
}

export const useAuthSessionStore = createWithEqualityFn(
	persist<AuthSessionStore>(
		(set, get) => ({
			accessToken: undefined,
			setAccessToken: (accessToken: string) => set({ accessToken }),
			clearState: () =>
				set({
					accessToken: undefined,
				}),
		}),
		{
			name: 'kumopack-supplier-auth-session-storage',
			storage: createJSONStorage(() => sessionStorage),
		}
	),
	Object.is
)
